import type { SportsAnimalRacingMeetingsState } from './types';

export const defaultState: SportsAnimalRacingMeetingsState = {
  isLoading: false,
  hasPreloaded: false,
  templateGroups: [],
  meetings: {},
  races: {}
};
